import type { RouteRecordRaw } from "vue-router";

import { PalletCheckerRoutes, TestPalletCheckerRoutes } from "../enums/routes/PalletCheckerRoutes";
import BetaPalletCheckerLayout from "../layout/app/beta/PalletCheckerLayout.vue";
import PalletCheckerLayout from "../layout/app/production/PalletCheckerLayout.vue";

export function palletCheckerRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/pallet-checker",
            component: PalletCheckerLayout,
            children: [
                {
                    path: "/pallet-checker",
                    name: PalletCheckerRoutes.IDLE,
                    component: () => import("../views/apps/palletChecker/PalletCheckerIdleView.vue"),
                },
                {
                    path: "/pallet-checker/signin",
                    name: PalletCheckerRoutes.SIGNIN,
                    component: () => import("../views/apps/palletChecker/PalletCheckerSignInView.vue"),
                },
                {
                    path: "/pallet-checker/settings",
                    name: PalletCheckerRoutes.SETTINGS,
                    component: () => import("../views/apps/palletChecker/PalletCheckerSettingsView.vue"),
                },
            ],
        },
        {
            path: "/test/pallet-checker",
            component: BetaPalletCheckerLayout,
            children: [
                {
                    path: "/test/pallet-checker",
                    name: TestPalletCheckerRoutes.IDLE,
                    component: () => import("../views/apps/test/palletChecker/PalletCheckerIdleView.vue"),
                },
                {
                    path: "/test/pallet-checker/signin",
                    name: TestPalletCheckerRoutes.SIGNIN,
                    component: () => import("../views/apps/test/palletChecker/PalletCheckerSignInView.vue"),
                },
                {
                    path: "/test/pallet-checker/settings",
                    name: TestPalletCheckerRoutes.SETTINGS,
                    component: () => import("../views/apps/test/palletChecker/PalletCheckerSettingsView.vue"),
                },
            ],
        },
    ];
}
